export default class DesignUploadCtaPlpErrorClass {
  #error;

  #errorMessageSelector = ".js-plp-error-message";

  constructor(error) {
    this.#error = error;
  }

  get #$errorMessage() {
    return document.querySelector(this.#errorMessageSelector);
  }

  showError() {
    this.#$errorMessage.classList.remove("hidden");
    this.#$errorMessage.textContent = this.#error;
    setTimeout(() => {
      this.#$errorMessage.classList.add("hidden");
    }, 5000);
  }
}
